<template>
  <v-container class="pa-5">
    <v-card class="">
      <v-toolbar flat elevation="4">
        <v-card class="icon">
          <v-icon
            style="margin-left: 30px; margin-top: 25px"
            color="white"
            x-large=""
            >mdi-chart-histogram</v-icon
          >
        </v-card>
        <div class="usuario"><h3>LISTADO DE REPORTES</h3></div>
      </v-toolbar>
      <v-row>
        <v-col cols="12">
          <v-container fluid class="mt-5">
            <v-row>
              <v-col cols="12" sm="4">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="dates"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dates"
                      label="Selecciona el rango de fechas para consultar tickets "
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      color="#1D3C7F"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    locale="es-es"
                    range
                    v-model="dates"
                    no-title
                    scrollable
                    color="#294697"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="#294697" @click="menu = false">
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="#294697"
                      @click="consultarIncidentes(dates)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="4">
                <v-btn
                  :loading="loading"
                  color="#294697"
                  tile
                  dark
                  class="mt-1"
                  @click="buscarIncidentes()"
                >
                  <v-icon> mdi-magnify </v-icon>
                  Buscar
                </v-btn>
              </v-col>
              <v-col cols="12" sm="4">
                <v-select
                  v-model="selectedEmpresa"
                  :items="empresasOptions"
                  item-text="text"
                  item-value="value"
                  label="Empresa"
                  dense
                  outlined
                  color="#1D3C7F"
                  class="mt-1"
                ></v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
      <v-container>
        <!-- Grafica de cantidad de casos por dia -->
        <div class="containt-charts">
          <v-card width="100%" max-height="">
            <v-card-title class="d-flex justify-center card-chart">
              <v-card tile width="95%" class="card--color1">
                <v-card-text class="card-chart--text">
                  <canvas id="CasosDiasMes"></canvas>
                </v-card-text>
              </v-card>
            </v-card-title>
            <v-card-subtitle class="title-card">
              {{ dataDias.titulo }}
            </v-card-subtitle>
            <v-divider></v-divider>
            <v-card-text class="subtitle-card">
              {{ dataDias.sub }}
            </v-card-text>
          </v-card>
        </div>
        <!-- Grafica de cantidad de cada requerimiento -->
        <v-row>
          <v-col cols="12" sm="8">
            <div class="containt-charts">
              <v-card width="750" max-height="">
                <v-card-title class="d-flex justify-center card-chart">
                  <v-card tile width="680" class="card--color2">
                    <v-card-text class="card-chart--text">
                      <canvas id="CasosPorRequerimientos" height="500"></canvas>
                    </v-card-text>
                  </v-card>
                </v-card-title>
                <v-card-subtitle class="title-card">
                  {{ dataRequerimientos.titulo }}
                </v-card-subtitle>
                <v-divider></v-divider>
                <v-card-text class="subtitle-card">
                  {{ dataRequerimientos.sub }}
                </v-card-text>
              </v-card>
            </div>
          </v-col>
          <v-col cols="12" sm="4">
            <!-- Grafica 3 -->
            <div class="containt-charts">
              <v-card width="750" max-height="">
                <v-card-title class="d-flex justify-center card-chart">
                  <v-card width="680" class="p-0 card--color3">
                    <v-card-text class="card-chart--text">
                      <canvas height="350" id="estadoDeCasos"></canvas>
                    </v-card-text>
                  </v-card>
                </v-card-title>
                <v-card-subtitle class="title-card">
                  REPORTE DE ESTADO DE CASOS
                </v-card-subtitle>
                <v-divider></v-divider>
                <v-card-text class="subtitle-card">
                  Reporte que muestra la cantidad de casos atentidos por el
                  robot 
                  <span class="font-weight-bold">({{ cerradoRobot }})</span
                  >, por el usuario
                  <span class="font-weight-bold">({{ cerradosUser }})</span> y los
                  casos pendientes
                  <span class="font-weight-bold"
                    >({{ pendientesPorCerrar }}) 
                  </span>
                  <br>
                  Total de casos:
                  <span class="font-weight-bold" style="color: #F34A3B"
                    >{{ total }} </span
                  >
                </v-card-text>
              </v-card>
            </div>
            <!-- Grafica 4 -->
            <div class="containt-charts">
              <v-card width="750" max-height="">
                <v-card-title class="d-flex justify-center card-chart">
                  <v-card width="680" class="p-0 card--color4">
                    <v-card-text class="card-chart--text">
                      <canvas height="350" id="porcentajeCumplimiento"></canvas>
                    </v-card-text>
                  </v-card>
                </v-card-title>
                <v-card-subtitle class="title-card">
                  REPORTE DE CUMPLIMIENTO
                </v-card-subtitle>
                <v-divider></v-divider>
                <v-card-text class="subtitle-card">
                  Reporte que muestra el porcentaje de cumplimiento de casos
                  atendidos en el area el cual es del
                  <span class="font-weight-bold" style="color: #3feb4e">{{ porcentajeCumplimiento }} %</span>
                </v-card-text>
              </v-card>
            </div>
          </v-col>
        </v-row>
        
        <!-- ⚠️ DIÁLOGO DE FECHAS PARA ESPECIALISTAS - SIN MODIFICACIONES ESTRUCTURALES ⚠️ -->
        <v-dialog v-model="dialog" persistent max-width="290">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              class="fecha"
              v-model="dateRangeDisplay"
              label="Selecciona el rango de fechas"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-card>
            <v-card-title>Selecciona un rango de fechas</v-card-title>
            <v-date-picker
              v-model="dateRange"
              locale="es-es"
              :range="true"
            ></v-date-picker>
            <v-card-actions>
              <v-btn text color="blue" @click="dialog = false">Cancelar</v-btn>
              <v-btn text color="blue" @click="aceptarFechas">
                Aceptar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- 🟢 GRÁFICA DE ESPECIALISTAS - ÚNICA SECCIÓN CORREGIDA 🟢 -->
        <template>
          <v-card width="100%" class="especialistas-card">
            <v-card-title class="d-flex justify-center card-chart-title">
              <v-card tile width="96%" class="card-chart-container">
                <v-card-text class="card-chart-text pa-0">
                  <!-- Contenedor con altura fija - SOLUCIÓN PARA EL RENDERIZADO -->
                  <div style="position: relative; height: 450px; width: 100%;">
                    <canvas 
                      id="graficoEspecialistas" 
                      ref="graficoRef"
                      style="display: block; width: 100%; height: 100%;"
                    ></canvas>
                  </div>
                </v-card-text>
              </v-card>
            </v-card-title>
            <v-card-subtitle class="title-card">
              Casos asignados por especialista
            </v-card-subtitle>
            <v-divider></v-divider>
            <v-card-text class="subtitle-card">
              Número de casos asignados a cada especialista en el sistema.
            </v-card-text>
          </v-card>

          <!-- Spinner con el icono mdi-reload y el texto "Cargando..." debajo -->
          <v-overlay
            v-if="loading"
            :value="loading"
            opacity="0.5"
            class="loading-overlay"
          >
            <div class="loading-container">
              <v-icon class="mdi-reload loading-icon" />
              <span class="loading-text">Cargando...</span>
            </div>
          </v-overlay>
        </template>
      </v-container> 
    </v-card>
    
    <!-- ⚠️ TODOS LOS DIÁLOGOS EXISTENTES SE MANTIENEN IGUAL ⚠️ -->
    <v-snackbar
      v-model="snackbar"
      :bottom="y === 'bottom'"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :right="x === 'right'"
      :timeout="timeout"
      :top="y === 'top'"
      :vertical="mode === 'vertical'"
      color="#294697"
      style="color: white"
    >
      {{ text }}
      <v-btn color="#294697" depressed @click="snackbar = false">Cerrar</v-btn>
    </v-snackbar>
    
    <!-- Modal de conversación -->
    <v-dialog v-model="dialog2" max-width="500px" persistent>
      <v-card>
        <v-card-title class="nav">
          <span class="headline" style="color: white">
            <v-icon color="white">mdi-message-bulleted</v-icon>
            Detalles
          </span>
        </v-card-title>
        <v-card-text>
          <div v-for="(chat, index) in chatItem" :key="index">
            <v-card class="mt-3 mx-auto" width="550">
              <v-card-subtitle v-if="chat.user == 'NOVA'" class="pb-0">
                <p class="indigo--text text--darken-3">
                  <v-icon color="indigo darken-4" class="ml-5 mr-1">mdi-robot</v-icon>
                  {{ chat.user }}
                </p>
              </v-card-subtitle>
              <v-card-subtitle v-else class="d-flex justify-end">
                <p class="deep-purple--text text--accent-3">
                  <v-icon color="deep-purple accent-4" class="ml-5 mr-1">mdi-face</v-icon>
                  {{ chat.user }}
                </p>
              </v-card-subtitle>
              <v-card-text v-if="chat.user == 'NOVA'" class="">
                <p class="grey--text text--darken-1 text-left">{{ chat.message }}</p>
              </v-card-text>
              <v-card-text v-else class="d-flex justify-end">
                <p class="grey--text text--darken-1 text-right">{{ chat.message }}</p>
              </v-card-text>
            </v-card>
          </div>
          <v-divider class="mt-5"></v-divider>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#1D3C7F" dark @click="verEvidencias(idCasoActual)" class="mr-2">
            <v-icon left>mdi-image-multiple</v-icon>
            VER EVIDENCIAS
          </v-btn>
          <v-btn color="#1D3C7F" dark @click="dialog2 = false">CERRAR</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <!-- Diálogo de evidencias -->
    <v-dialog v-model="dialogEvidencias" max-width="900px">
      <v-card>
        <v-card-title class="nav">
          <span class="headline" style="color: white">
            <v-icon color="white">mdi-image-multiple</v-icon>
            Evidencias del caso #{{ idCasoActual }}
          </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <div v-if="cargandoEvidencias" class="text-center my-5">
              <v-progress-circular indeterminate color="#294697"></v-progress-circular>
              <p>Cargando evidencias...</p>
            </div>
            <div v-else-if="!evidencias.length" class="text-center my-5">
              <v-alert type="info" outlined>
                No hay evidencias disponibles para este caso.
              </v-alert>
            </div>
            <v-row v-else>
              <v-col v-for="(evidencia, index) in evidencias" :key="index" cols="12" sm="6" md="4">
                <v-card outlined>
                  <template v-if="isImageUrl(evidencia.cc_ruta_evidencia)">
                    <v-img
                      :src="evidencia.cc_ruta_evidencia"
                      aspect-ratio="1"
                      class="grey lighten-2"
                      @click="verImagenCompleta(evidencia.cc_ruta_evidencia)"
                      style="cursor: pointer"
                    >
                      <template v-slot:placeholder>
                        <v-row class="fill-height ma-0" align="center" justify="center">
                          <v-progress-circular indeterminate color="#294697"></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </template>
                  <template v-else>
                    <v-card
                      class="d-flex flex-column align-center justify-center pa-3"
                      style="cursor: pointer; aspect-ratio: 1; height: 100%;"
                      @click="downloadFile(evidencia.cc_ruta_evidencia)"
                    >
                      <v-icon size="80" color="grey darken-1">mdi-file-document-outline</v-icon>
                      <div class="mt-2 text-caption grey--text text--darken-1 text-center" style="word-break: break-all;">
                        {{ getFileName(evidencia.cc_ruta_evidencia) }}
                      </div>
                    </v-card>
                  </template>
                  <v-card-text class="pa-2">
                    <small class="grey--text">{{ formatDate(evidencia.fecha_subida) }}</small>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#1D3C7F" dark @click="closeEvidencias">CERRAR</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <!-- Diálogo de imagen completa -->
    <v-dialog v-model="dialogImagenCompleta" max-width="90vw" fullscreen>
      <v-card flat>
        <v-toolbar dark color="#1D3C7F" flat>
          <v-btn icon dark @click="descargarImagen">
            <v-icon>mdi-download</v-icon>
          </v-btn>
          <v-toolbar-title>Evidencia</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialogImagenCompleta = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-0 d-flex justify-center align-center" style="height: calc(100vh - 64px); background-color: #000;">
          <img :src="imagenSeleccionada" style="max-height: 95vh; max-width: 95vw; object-fit: contain;" />
        </v-card-text>
      </v-card>
    </v-dialog>
    
    <!-- Diálogo de imagen de cierre -->
    <v-dialog v-model="dialogImagenCierre" max-width="500px" max-height="400px" persistent>
      <v-card>
        <v-card-title class="nav">
          <span class="headline" style="color: white">
            <v-icon color="white">mdi-image</v-icon>
            Evidencia del Caso
          </span>
        </v-card-title>
        <v-card-text class="pa-5">
          <v-img v-if="cc_ruta" :src="cc_ruta" alt="Imagen"></v-img>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#294697" dark @click="dialogImagenCierre = false">CERRAR</v-btn>
          <v-btn color="#1D3C7F" dark @click="aumentarImagen">Aumentar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import env from "@/components/env";
import axios from "axios";
import Chart from "chart.js";
import ChartDataLabels from 'chartjs-plugin-datalabels';

Chart.defaults.global.defaultFontColor = "#000";
Chart.defaults.global.defaultFontSize = 11;
Chart.plugins.register(ChartDataLabels);

export default {
  name: "Inicio",
  data() {
    return {
      idCargo: localStorage.getItem("idCargo"),
      dataDias: {
        titulo: "",
        sub: "",
      },
      dates: ["", ""],
      fecha: [""],
      casosEspecialistas: [], 
      menu: false,
      fechaInicio: "",
      fechaActual: "",
      dialog: false,
      loading: false,
      cerradosUser: 0,
      cerradoRobot: 0,
      pendientesPorCerrar: 0,
      total: 0,
      porcentajeCumplimiento: 0,
      dataRequerimientos: {
        titulo: "",
        sub: "",
        altoGrafica: "250",
      },
      values: [],
      snackbar: false,
      text: "",
      timeout: 5000,
      y: "top",
      x: null,
      mode: "",
      selectedDate: "",
      chart: null,
      dateRange: ["", ""],
      dateRangeDisplay: '',
      selectedDate: null,
      casosPorEspecialista: [],
      dialog2: false,
      chatItem: [],
      idCasoActual: null,
      dialogEvidencias: false,
      cargandoEvidencias: false,
      evidencias: [],
      imagenSeleccionada: '',
      dialogImagenCompleta: false,
      dialogImagenCierre: false,
      cc_ruta: '',
      selectedEmpresa: 0,
      empresasOptions: [
        { text: 'Todas', value: 0 },
        { text: 'FACILISIMO', value: 1 },
        { text: 'APOSTAR', value: 2 },
      ],
      // 🟢 NUEVA PROPIEDAD PARA EL CHART DE ESPECIALISTAS
      chartEspecialistas: null,
    };
  },
  
  computed: {
    nombreEmpresa() {
      const empresa = this.empresasOptions.find(e => e.value === this.selectedEmpresa);
      return empresa ? empresa.text : 'Todas';
    }
  },
  
  created() {
    this.obtenerFechas();
  },
  
  mounted() {
    this.getChartsForMonth();
    if ((this.dateRange && this.dateRange.length === 2) || (this.dates && this.dates.length === 2)) {
      this.$nextTick(() => {
        setTimeout(() => {
          this.consultarIncidentesPorRango();
        }, 500);
      });
    }
  },
  
  watch: {
    selectedEmpresa(newVal, oldVal) {
      if (this.dates && this.dates.length === 2 && this.dates[0] && this.dates[1] && oldVal !== undefined && newVal !== oldVal) {
        this.getChartsForMonth();
        if ((this.dateRange && this.dateRange.length === 2) || (this.dates && this.dates.length === 2)) {
          this.consultarIncidentesPorRango();
        }
      }
    }
  },
  
  methods: {
    notificar(tipo, mensaje) {
      this.snackbar = true;
      this.text = mensaje;
    },

    // 🟢 MÉTODO COMPLETAMENTE CORREGIDO PARA LA GRÁFICA DE ESPECIALISTAS 🟢
    graficarCasosPorEspecialista() {
      this.$nextTick(() => {
        const canvas = document.getElementById("graficoEspecialistas");
        const canvasRef = this.$refs.graficoRef;
        const canvasElement = canvas || canvasRef;
        
        if (!canvasElement) {
          console.error("ERROR - Canvas 'graficoEspecialistas' no encontrado");
          setTimeout(() => this.graficarCasosPorEspecialista(), 200);
          return;
        }

        // 🔥 FIJAR DIMENSIONES EXPLÍCITAS
        const container = canvasElement.parentElement;
        if (container) {
          const containerWidth = container.clientWidth || 800;
          const containerHeight = container.clientHeight || 450;
          canvasElement.width = containerWidth;
          canvasElement.height = containerHeight;
          canvasElement.style.width = `${containerWidth}px`;
          canvasElement.style.height = `${containerHeight}px`;
        } else {
          canvasElement.width = 800;
          canvasElement.height = 450;
          canvasElement.style.width = '800px';
          canvasElement.style.height = '450px';
        }

        const ctx = canvasElement.getContext("2d");

        let especialistasFiltrados = Array.isArray(this.casosPorEspecialista) 
          ? this.casosPorEspecialista 
          : [];

        if (especialistasFiltrados.length === 0) {
          if (this.chartEspecialistas) {
            this.chartEspecialistas.destroy();
            this.chartEspecialistas = null;
          }
          ctx.clearRect(0, 0, canvasElement.width, canvasElement.height);
          ctx.fillStyle = "#f8f9fa";
          ctx.fillRect(0, 0, canvasElement.width, canvasElement.height);
          ctx.font = "16px Arial";
          ctx.fillStyle = "#666";
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";
          ctx.fillText("No hay datos para mostrar", canvasElement.width / 2, canvasElement.height / 2);
          return;
        }

        especialistasFiltrados.sort((a, b) => {
          const totalA = parseInt(a.total) || 0;
          const totalB = parseInt(b.total) || 0;
          return totalB - totalA;
        });

        const labels = especialistasFiltrados.map((item) => {
          let label = item.especialista || 'Sin nombre';
          if (this.selectedEmpresa === 0 && item.idEmpresaEspecialista) {
            const empresaNombre = item.idEmpresaEspecialista == 1 ? 'FACILISIMO' : 
                                 (item.idEmpresaEspecialista == 2 ? 'APOSTAR' : '');
            if (empresaNombre) {
              label = `${label} (${empresaNombre})`;
            }
          }
          return label;
        });
        
        const data = especialistasFiltrados.map((item) => parseInt(item.total) || 0);

        if (this.chartEspecialistas) {
          this.chartEspecialistas.destroy();
          this.chartEspecialistas = null;
        }

        // 🔥 CONFIGURACIÓN OPTIMIZADA PARA CHART.JS V2
        this.chartEspecialistas = new Chart(ctx, {
          type: "bar",
          data: {
            labels: labels,
            datasets: [
              {
                label: "Total de casos",
                data: data,
                backgroundColor: "rgba(54, 162, 235, 0.7)",
                borderColor: "rgba(54, 162, 235, 1)",
                borderWidth: 1.5,
              },
            ],
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            layout: {
              padding: {
                top: 20,
                bottom: 40,
                left: 10,
                right: 20
              }
            },
            scales: {
              xAxes: [{
                ticks: {
                  maxRotation: 45,
                  minRotation: 30,
                  autoSkip: false,
                  fontSize: 11,
                  fontColor: '#333',
                  padding: 8
                },
                gridLines: {
                  display: false,
                  drawBorder: true
                },
                barPercentage: 0.6,
                categoryPercentage: 0.7
              }],
              yAxes: [{
                ticks: {
                  beginAtZero: true,
                  stepSize: 1,
                  precision: 0,
                  fontSize: 11,
                  fontColor: '#333',
                  padding: 10,
                  maxTicksLimit: 10
                },
                gridLines: {
                  display: true,
                  color: 'rgba(0, 0, 0, 0.08)',
                  lineWidth: 1,
                  drawBorder: true
                }
              }]
            },
            legend: {
              display: true,
              position: 'top',
              labels: {
                fontSize: 12,
                fontColor: '#333',
                padding: 15,
                usePointStyle: true,
                boxWidth: 8
              }
            },
            tooltips: {
              enabled: true,
              backgroundColor: 'rgba(0, 0, 0, 0.8)',
              titleFontSize: 12,
              bodyFontSize: 11,
              titleFontColor: '#fff',
              bodyFontColor: '#fff',
              borderColor: 'rgba(255, 255, 255, 0.2)',
              borderWidth: 1,
              xPadding: 10,
              yPadding: 8,
              caretPadding: 5,
              callbacks: {
                label: function(tooltipItem, data) {
                  return ` Casos: ${tooltipItem.yLabel}`;
                }
              }
            },
            plugins: {
              datalabels: {
                display: 'auto',
                anchor: 'end',
                align: 'top',
                offset: 4,
                formatter: function(value) {
                  return value > 0 ? value : '';
                },
                font: {
                  weight: 'bold',
                  size: 11
                },
                color: '#333',
                backgroundColor: 'rgba(255, 255, 255, 0.7)',
                padding: {
                  top: 2,
                  bottom: 2,
                  left: 4,
                  right: 4
                },
                borderRadius: 3
              }
            },
            animation: {
              duration: 800,
              easing: 'easeOutQuart'
            },
            hover: {
              mode: 'index',
              intersect: true,
              animationDuration: 200
            },
            responsiveAnimationDuration: 300,
            events: ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'],
          }
        });
        
        this.chartEspecialistas.update();
      });
    },

    // 🟢 MÉTODO CORREGIDO PARA CONSULTAR INCIDENTES POR RANGO
    consultarIncidentesPorRango() {
      let [fechaInicio, fechaFin] = this.dateRange && this.dateRange.length === 2 
        ? this.dateRange 
        : (this.dates && this.dates.length === 2 ? this.dates : []);

      if (fechaInicio && fechaFin) {
        fechaInicio = typeof fechaInicio === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(fechaInicio) 
          ? fechaInicio 
          : new Date(fechaInicio).toISOString().split('T')[0];
        
        fechaFin = typeof fechaFin === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(fechaFin) 
          ? fechaFin 
          : new Date(fechaFin).toISOString().split('T')[0];
        
        if (Date.parse(fechaInicio) > Date.parse(fechaFin)) {
          [fechaInicio, fechaFin] = [fechaFin, fechaInicio];
        }
      } else {
        const hoy = new Date();
        const haceUnaSemana = new Date(hoy);
        haceUnaSemana.setDate(hoy.getDate() - 7);
        fechaInicio = haceUnaSemana.toISOString().split("T")[0];
        fechaFin = hoy.toISOString().split("T")[0];
      }

      this.loading = true;

      const idEmpresa = this.selectedEmpresa !== null && this.selectedEmpresa !== undefined 
        ? parseInt(this.selectedEmpresa) 
        : 0;

      const idCargoUsuario = localStorage.getItem("idCargo");
      const idAreaUsuario = localStorage.getItem("idArea");

      const params = {
        fechaInicio,
        fechaFin,
        idEmpresa: idEmpresa,
        idCargoUsuario: idCargoUsuario,
        idAreaUsuario: idAreaUsuario,
      };

      axios.get(`${env.endpoint}callcenter/casosPorEspecialista`, { params })
        .then((response) => {
          if (!Array.isArray(response.data)) {
            console.error("ERROR - La respuesta no es un array:", response.data);
            this.casosPorEspecialista = [];
          } else {
            this.casosPorEspecialista = response.data;
          }
          
          // 🟢 ESPERAR A QUE EL DOM SE ACTUALICE
          setTimeout(() => {
            this.graficarCasosPorEspecialista();
          }, 100);
        })
        .catch((error) => {
          console.error("Error al obtener los datos:", error);
          this.casosPorEspecialista = [];
          setTimeout(() => {
            this.graficarCasosPorEspecialista();
          }, 100);
          this.notificar(
            "error",
            "Ocurrió un error al obtener los datos. Intenta nuevamente."
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // ⚠️ TODOS LOS MÉTODOS EXISTENTES SE MANTIENEN EXACTAMENTE IGUAL ⚠️
    consultarCasos(fecha) {
      this.$refs.dialog.save(fecha);
    },

    getChartsForMonth() {
      let dataDias = new Array();
      let keyDataDias = new Array();
      let dataRequerimientos = new Array();
      let keyDataRequerimientos = new Array();

      const idEmpresa = this.selectedEmpresa !== null && this.selectedEmpresa !== undefined ? parseInt(this.selectedEmpresa) : 0;

      axios
        .get(
          `${env.endpoint}callcenter/reporte_casos_dia?idCargo=${this.idCargo}&fechaInicio=${this.dates[0]}&fechaFin=${this.dates[1]}&idEmpresa=${idEmpresa}`
        )
        .then((res) => {
          if (!res || !res.data) {
            console.error("Error: respuesta del servidor inválida", res);
            this.notificar("error", "Error al obtener los datos del servidor.");
            return;
          }

          // Grafica 1 - Casos por días
          const ctx = document.getElementById("CasosDiasMes");
          if (window.myChartCasosDias) {
            window.myChartCasosDias.destroy();
          }

          if (idEmpresa === 0 && res.data.dias_facilisimo && res.data.dias_apostar) {
            let keyDataDiasFaci = [];
            let dataDiasFaci = [];
            if (res.data.dias_facilisimo.data && Object.keys(res.data.dias_facilisimo.data).length > 0) {
              for (var key in res.data.dias_facilisimo.data) {
                keyDataDiasFaci.push(key.substring(5, 11));
                dataDiasFaci.push(res.data.dias_facilisimo.data[key]);
              }
            }

            let keyDataDiasApo = [];
            let dataDiasApo = [];
            if (res.data.dias_apostar.data && Object.keys(res.data.dias_apostar.data).length > 0) {
              for (var key in res.data.dias_apostar.data) {
                keyDataDiasApo.push(key.substring(5, 11));
                dataDiasApo.push(res.data.dias_apostar.data[key]);
              }
            }

            if (keyDataDiasFaci.length === 0 && keyDataDiasApo.length === 0 && res.data.dias && res.data.dias.data) {
              for (var key in res.data.dias.data) {
                keyDataDias.push(key.substring(5, 11));
                dataDias.push(res.data.dias.data[key]);
              }
              const empresaTexto = this.nombreEmpresa !== 'Todas' ? ` - ${this.nombreEmpresa}` : '';
              this.dataDias.sub = (res.data.dias.sub || '') + empresaTexto;
              this.dataDias.titulo = (res.data.dias.titulo || '') + empresaTexto;

              window.myChartCasosDias = new Chart(ctx, {
                type: "line",
                data: {
                  labels: keyDataDias,
                  datasets: [
                    {
                      label: "Casos por días",
                      type: "bar",
                      data: dataDias,
                      backgroundColor: "rgba(71, 183,132,.5)",
                      borderColor: "#47b784",
                      borderWidth: 1,
                    },
                  ],
                },
                options: {
                  responsive: true,
                  lineTension: 1,
                  plugins: {
                    tooltip: {
                      enabled: false,
                    },
                  },
                  interaction: {
                    mode: 'none',
                  },
                  scales: {
                    yAxes: [
                      {
                        ticks: {
                          beginAtZero: true,
                          padding: 25,
                        },
                      },
                    ],
                  },
                },
              });
            } else {
              const allDates = [...new Set([...keyDataDiasFaci, ...keyDataDiasApo])].sort();
              
              let finalDates = allDates;
              if (allDates.length === 0 && this.dates && this.dates.length === 2) {
                const startDate = new Date(this.dates[0]);
                const endDate = new Date(this.dates[1]);
                finalDates = [];
                const currentDate = new Date(startDate);
                while (currentDate <= endDate) {
                  const month = String(currentDate.getMonth() + 1).padStart(2, '0');
                  const day = String(currentDate.getDate()).padStart(2, '0');
                  finalDates.push(`${month}-${day}`);
                  currentDate.setDate(currentDate.getDate() + 1);
                }
              }
              
              const dataDiasFaciAligned = finalDates.map(date => {
                const index = keyDataDiasFaci.indexOf(date);
                return index >= 0 ? dataDiasFaci[index] : 0;
              });
              const dataDiasApoAligned = finalDates.map(date => {
                const index = keyDataDiasApo.indexOf(date);
                return index >= 0 ? dataDiasApo[index] : 0;
              });

              const datasets = [];
              if (res.data.dias_facilisimo) {
                datasets.push({
                  label: "FACILISIMO",
                  type: "bar",
                  data: dataDiasFaciAligned,
                  backgroundColor: "rgba(71, 183, 132, 0.5)",
                  borderColor: "#47b784",
                  borderWidth: 1,
                });
              }
              if (res.data.dias_apostar) {
                datasets.push({
                  label: "APOSTAR",
                  type: "bar",
                  data: dataDiasApoAligned,
                  backgroundColor: "rgba(72, 90, 154, 0.5)",
                  borderColor: "#485a9a",
                  borderWidth: 1,
                });
              }

              if (datasets.length > 0) {
                this.dataDias.sub = (res.data.dias && res.data.dias.sub ? res.data.dias.sub : '') + ' (Combinados)';
                this.dataDias.titulo = (res.data.dias && res.data.dias.titulo ? res.data.dias.titulo : '') + ' (Combinados)';

                window.myChartCasosDias = new Chart(ctx, {
                  type: "line",
                  data: {
                    labels: finalDates.length > 0 ? finalDates : ['Sin datos'],
                    datasets: datasets,
                  },
                  options: {
                    responsive: true,
                    lineTension: 1,
                    plugins: {
                      tooltip: {
                        enabled: true,
                      },
                      legend: {
                        display: true,
                        position: 'top',
                        labels: {
                          filter: function(item, chart) {
                            return true;
                          }
                        }
                      },
                    },
                    interaction: {
                      mode: 'index',
                    },
                    scales: {
                      yAxes: [
                        {
                          ticks: {
                            beginAtZero: true,
                            padding: 25,
                            min: 0,
                            stepSize: 1,
                          },
                        },
                      ],
                    },
                    elements: {
                      bar: {
                        minBarLength: 2,
                      }
                    },
                  },
                });
              }
            }
          } else if (res.data.dias && res.data.dias.data) {
            for (var key in res.data.dias.data) {
              keyDataDias.push(key.substring(5, 11));
              dataDias.push(res.data.dias.data[key]);
            }
            const empresaTexto = this.nombreEmpresa !== 'Todas' ? ` - ${this.nombreEmpresa}` : '';
            this.dataDias.sub = (res.data.dias.sub || '') + empresaTexto;
            this.dataDias.titulo = (res.data.dias.titulo || '') + empresaTexto;

            window.myChartCasosDias = new Chart(ctx, {
              type: "line",
              data: {
                labels: keyDataDias,
                datasets: [
                  {
                    label: "Casos por días",
                    type: "bar",
                    data: dataDias,
                    backgroundColor: "rgba(71, 183,132,.5)",
                    borderColor: "#47b784",
                    borderWidth: 1,
                  },
                ],
              },
              options: {
                responsive: true,
                lineTension: 1,
                plugins: {
                  tooltip: {
                    enabled: false,
                  },
                },
                interaction: {
                  mode: 'none',
                },
                scales: {
                  yAxes: [
                    {
                      ticks: {
                        beginAtZero: true,
                        padding: 25,
                      },
                    },
                  ],
                },
              },
            });
          } else {
            console.warn("No se encontraron datos de días en la respuesta");
          }

          // Grafica 2 - Casos por requerimientos
          if (res.data.requerimientos && res.data.requerimientos.data) {
            const ctx2 = document.getElementById("CasosPorRequerimientos");
            if (window.myChartRequerimientos) {
              window.myChartRequerimientos.destroy();
            }
            
            if (idEmpresa === 0 && res.data.requerimientos_facilisimo && res.data.requerimientos_apostar) {
              let keyDataReqFaci = [];
              let dataReqFaci = [];
              if (res.data.requerimientos_facilisimo.data && Object.keys(res.data.requerimientos_facilisimo.data).length > 0) {
                for (var key in res.data.requerimientos_facilisimo.data) {
                  keyDataReqFaci.push(key);
                  dataReqFaci.push(res.data.requerimientos_facilisimo.data[key]);
                }
              }

              let keyDataReqApo = [];
              let dataReqApo = [];
              if (res.data.requerimientos_apostar.data && Object.keys(res.data.requerimientos_apostar.data).length > 0) {
                for (var key in res.data.requerimientos_apostar.data) {
                  keyDataReqApo.push(key);
                  dataReqApo.push(res.data.requerimientos_apostar.data[key]);
                }
              }

              if (keyDataReqFaci.length === 0 && keyDataReqApo.length === 0 && res.data.requerimientos && res.data.requerimientos.data) {
                for (var key in res.data.requerimientos.data) {
                  keyDataRequerimientos.push(key);
                  dataRequerimientos.push(res.data.requerimientos.data[key]);
                }
                const empresaTexto = this.nombreEmpresa !== 'Todas' ? ` - ${this.nombreEmpresa}` : '';
                this.dataRequerimientos.sub = (res.data.requerimientos.sub || '') + empresaTexto;
                this.dataRequerimientos.titulo = (res.data.requerimientos.titulo || '') + empresaTexto;
                
                window.myChartRequerimientos = new Chart(ctx2, {
                  type: "horizontalBar",
                  data: {
                    labels: keyDataRequerimientos,
                    datasets: [
                      {
                        axis: "y",
                        label: "Casos por requerimiento",
                        fill: false,
                        data: dataRequerimientos,
                        backgroundColor: "#485a9aa1",
                        borderColor: "#485a9a",
                        borderWidth: 1,
                      },
                    ],
                  },
                  options: {
                    indexAxis: "y",
                    lineTension: 1,
                    plugins: {
                      tooltip: {
                        enabled: false,
                      },
                    },
                    interaction: {
                      mode: 'none',
                    },
                    scales: {
                      yAxes: [
                        {
                          ticks: {
                            beginAtZero: false,
                            padding: 10,
                          },
                        },
                      ],
                    },
                  },
                });
              } else {
                const allReqKeys = [...new Set([...keyDataReqFaci, ...keyDataReqApo])];
                
                const dataReqFaciAligned = allReqKeys.map(key => {
                  const index = keyDataReqFaci.indexOf(key);
                  return index >= 0 ? dataReqFaci[index] : 0;
                });
                const dataReqApoAligned = allReqKeys.map(key => {
                  const index = keyDataReqApo.indexOf(key);
                  return index >= 0 ? dataReqApo[index] : 0;
                });

                const datasets = [];
                if (res.data.requerimientos_facilisimo) {
                  datasets.push({
                    label: "FACILISIMO",
                    axis: "y",
                    data: dataReqFaciAligned,
                    backgroundColor: "rgba(71, 183, 132, 0.5)",
                    borderColor: "#47b784",
                    borderWidth: 1,
                  });
                }
                if (res.data.requerimientos_apostar) {
                  datasets.push({
                    label: "APOSTAR",
                    axis: "y",
                    data: dataReqApoAligned,
                    backgroundColor: "rgba(72, 90, 154, 0.5)",
                    borderColor: "#485a9a",
                    borderWidth: 1,
                  });
                }

                if (datasets.length > 0) {
                  const empresaTexto = '';
                  this.dataRequerimientos.sub = (res.data.requerimientos && res.data.requerimientos.sub ? res.data.requerimientos.sub : '') + empresaTexto;
                  this.dataRequerimientos.titulo = (res.data.requerimientos && res.data.requerimientos.titulo ? res.data.requerimientos.titulo : '') + empresaTexto;

                  window.myChartRequerimientos = new Chart(ctx2, {
                    type: "horizontalBar",
                    data: {
                      labels: allReqKeys.length > 0 ? allReqKeys : ['Sin datos'],
                      datasets: datasets,
                    },
                    options: {
                      indexAxis: "y",
                      lineTension: 1,
                      plugins: {
                        tooltip: {
                          enabled: true,
                        },
                        legend: {
                          display: true,
                          position: 'top',
                          labels: {
                            filter: function(item, chart) {
                              return true;
                            }
                          }
                        },
                      },
                      interaction: {
                        mode: 'index',
                      },
                      scales: {
                        yAxes: [
                          {
                            ticks: {
                              beginAtZero: false,
                              padding: 10,
                            },
                          },
                        ],
                      },
                    },
                  });
                }
              }
            } else {
              for (var key in res.data.requerimientos.data) {
                keyDataRequerimientos.push(key);
                dataRequerimientos.push(res.data.requerimientos.data[key]);
              }
              const empresaTexto = this.nombreEmpresa !== 'Todas' ? ` - ${this.nombreEmpresa}` : '';
              this.dataRequerimientos.sub = (res.data.requerimientos.sub || '') + empresaTexto;
              this.dataRequerimientos.titulo = (res.data.requerimientos.titulo || '') + empresaTexto;
              
              window.myChartRequerimientos = new Chart(ctx2, {
                type: "horizontalBar",
                data: {
                  labels: keyDataRequerimientos,
                  datasets: [
                    {
                      axis: "y",
                      label: "Casos por requerimiento",
                      fill: false,
                      data: dataRequerimientos,
                      backgroundColor: "#485a9aa1",
                      borderColor: "#485a9a",
                      borderWidth: 1,
                    },
                  ],
                },
                options: {
                  indexAxis: "y",
                  lineTension: 1,
                  plugins: {
                    tooltip: {
                      enabled: false,
                    },
                  },
                  interaction: {
                    mode: 'none',
                  },
                  scales: {
                    yAxes: [
                      {
                        ticks: {
                          beginAtZero: false,
                          padding: 10,
                        },
                      },
                    ],
                  },
                },
              });
            }
          } else {
            console.warn("No se encontraron datos de requerimientos en la respuesta");
          }

          // Grafica 3 - Estado de casos
          if (idEmpresa === 0 && res.data.estado_facilisimo && res.data.estado_apostar) {
            const totalFaci = res.data.estado_facilisimo.total || 0;
            const totalApo = res.data.estado_apostar.total || 0;
            const robotFaci = res.data.estado_facilisimo.robot || 0;
            const robotApo = res.data.estado_apostar.robot || 0;
            const cierreUserFaci = res.data.estado_facilisimo.cierre_user || 0;
            const cierreUserApo = res.data.estado_apostar.cierre_user || 0;
            const cerradosFaci = res.data.estado_facilisimo.cerrados || 0;
            const cerradosApo = res.data.estado_apostar.cerrados || 0;

            const total = totalFaci + totalApo;
            const robot = robotFaci + robotApo;
            const cierreUser = cierreUserFaci + cierreUserApo;
            const cerrados = cerradosFaci + cerradosApo;

            let dataEstadoDeCasos = [cierreUser, robot, total - cerrados];
            this.total = total;
            this.cerradosUser = cierreUser;
            this.cerradoRobot = robot;
            this.pendientesPorCerrar = total - cerrados;
            
            const ctx3 = document.getElementById("estadoDeCasos");
            if (window.myChartEstado) {
              window.myChartEstado.destroy();
            }
            window.myChartEstado = new Chart(ctx3, {
              type: "doughnut",
              data: {
                labels: [
                  "Cerrados por los usuarios",
                  "Cerrados por el robot",
                  "Pendientes por cerrar",
                ],
                datasets: [
                  {
                    fill: false,
                    data: dataEstadoDeCasos,
                    backgroundColor: [
                      "rgba(235,63,63,0.5)",
                      "rgba(255,68,6,0.5)",
                      "rgba(6,33,255,0.5)",
                    ],
                    borderColor: ["#EB3F3F", "#FF4406", "#0621FF"],
                    borderWidth: 1,
                  },
                ],
              },
              options: {
                animation: {
                  animateRotate: true,
                },
                responsive: true,
                plugins: {
                  tooltip: {
                    enabled: false,
                  },
                },
                interaction: {
                  mode: 'none',
                },
              },
            });
          } else if (res.data && typeof res.data.cierre_user !== 'undefined' && typeof res.data.robot !== 'undefined' && typeof res.data.total !== 'undefined' && typeof res.data.cerrados !== 'undefined') {
            let dataEstadoDeCasos = new Array();
            dataEstadoDeCasos.push(res.data.cierre_user);
            dataEstadoDeCasos.push(res.data.robot);
            dataEstadoDeCasos.push(res.data.total - res.data.cerrados);
            this.total = res.data.total;
            this.cerradosUser = res.data.cierre_user;
            this.cerradoRobot = res.data.robot;
            this.pendientesPorCerrar = res.data.total - res.data.cerrados;
            const ctx3 = document.getElementById("estadoDeCasos");
            if (window.myChartEstado) {
              window.myChartEstado.destroy();
            }
            window.myChartEstado = new Chart(ctx3, {
              type: "doughnut",
              data: {
                labels: [
                  "Cerrados por los usuarios",
                  "Cerrados por el robot",
                  "Pendientes por cerrar",
                ],
                datasets: [
                  {
                    fill: false,
                    data: dataEstadoDeCasos,
                    backgroundColor: [
                      "rgba(235,63,63,0.5)",
                      "rgba(255,68,6,0.5)",
                      "rgba(6,33,255,0.5)",
                    ],
                    borderColor: ["#EB3F3F", "#FF4406", "#0621FF"],
                    borderWidth: 1,
                  },
                ],
              },
              options: {
                animation: {
                  animateRotate: true,
                },
                responsive: true,
                plugins: {
                  tooltip: {
                    enabled: false,
                  },
                },
                interaction: {
                  mode: 'none',
                },
              },
            });
          } else {
            console.warn("No se encontraron datos de estado en la respuesta");
          }
        })
        .catch((error) => {
          console.error("Error al obtener los datos:", error);
          this.notificar("error", "Ocurrió un error al obtener los datos. Intenta nuevamente.");
        });
    },

    obtenerFechas() {
      const date = new Date();
      this.fechaInicio = new Date(date.getFullYear(), date.getMonth(), 1);
      this.fechaInicio = this.formatDateToLocal(this.fechaInicio);
      this.fechaActual = this.formatDateToLocal(new Date());
      this.dates = [this.fechaInicio, this.fechaActual];
    },

    formatDateToLocal(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    consultarIncidentes(dates) {
      this.dates = dates.map(date => {
        const localDate = new Date(date);
        return localDate.toISOString().split('T')[0];
      });

      if (this.$refs.menu) {
        this.$refs.menu.save(this.dates);
      }
    },

    buscarIncidentes() {
      if (this.dates.length === 2) {
        const [startDate, endDate] = this.dates;

        if (new Date(startDate) > new Date(endDate)) {
            console.error("La fecha de inicio es posterior a la fecha de fin:", startDate, endDate);
            this.text = "La fecha de inicio no puede ser posterior a la fecha de fin.";
            this.snackbar = true;
            return;
        }

        this.loading = true;

        setTimeout(() => {
            this.loading = false;
            this.getChartsForMonth();
            if ((this.dateRange && this.dateRange.length === 2) || (this.dates && this.dates.length === 2)) {
              this.consultarIncidentesPorRango();
            }
          }, 2000);
      } else {
        console.error("Rango de fechas inválido:", this.dates);
        this.text = "Seleccione por favor dos fechas, de lo contrario no podrá filtrar los resultados.";
        this.snackbar = true;
      }
    },

    verConversacion(item) {
      this.dialog2 = true;
      this.idCasoActual = item.cc_id_caso;
      this.chatItem = typeof item.conversacion === 'string' ? JSON.parse(item.conversacion) : item.conversacion;
    },

    verEvidencias(idCaso) {
      this.idCasoActual = idCaso;
      this.dialogEvidencias = true;
      this.cargandoEvidencias = false;
      this.evidencias = [];
      axios.get(`${env.endpointTraerEvidencias}?cc_id_caso=${idCaso}`)
        .then(response => {
          this.evidencias = response.data.evidencias;
        })
        .catch(error => {
          this.text = "Error al cargar las evidencias";
          this.snackbar = true;
        })
        .finally(() => {
          this.cargandoEvidencias = false;
        });
    },
    
    closeEvidencias() {
      this.dialogEvidencias = false;
      this.evidencias = [];
    },
    
    verImagenCompleta(url) {
      this.imagenSeleccionada = url;
      this.dialogImagenCompleta = true;
    },
    
    descargarImagen() {
      const link = document.createElement('a');
      link.href = this.imagenSeleccionada;
      link.download = this.imagenSeleccionada.split('/').pop();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    
    isImageUrl(url) {
      if (!url) return false;
      return /\.(jpeg|jpg|gif|png|webp|svg)$/i.test(url);
    },
    
    getFileName(url) {
      if (!url) return 'Archivo';
      try {
        const fullPath = new URL(url).pathname;
        return fullPath.substring(fullPath.lastIndexOf('/') + 1);
      } catch (e) {
        const parts = url.split('/');
        return parts[parts.length - 1] || 'Archivo';
      }
    },
    
    formatDate(dateString) {
      const options = { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' };
      return new Date(dateString).toLocaleDateString('es-ES', options);
    },
    
    verImagen(item) {
      this.dialogImagenCierre = true;
      this.cc_ruta = item.cc_ruta;
    },
    
    aumentarImagen() {
      this.imagenSeleccionada = this.cc_ruta;
      this.dialogImagenCierre = false;
      this.dialogImagenCompleta = true;
    },
    
aceptarFechas() {
  if (this.dateRange && this.dateRange.length === 2) {
    // ✅ PASO 1: Obtener las fechas como strings YYYY-MM-DD
    const [fechaInicio, fechaFin] = this.dateRange.map(date => {
      // Si ya viene en formato YYYY-MM-DD, usarlo directamente
      if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
        return date;
      }
      // Si es un objeto Date, convertirlo a YYYY-MM-DD sin usar getDate() que cambia la fecha
      const dateObj = new Date(date);
      // ✅ FORMA CORRECTA: usar toISOString() y tomar solo la fecha
      return dateObj.toISOString().split('T')[0];
    });
    
    // ✅ PASO 2: Guardar las fechas exactas (sin modificar)
    this.dateRange = [fechaInicio, fechaFin];
    
    // ✅ PASO 3: MOSTRAR DIRECTAMENTE LOS STRINGS, SIN CONVERTIR A DATE
    this.dateRangeDisplay = `${fechaInicio} - ${fechaFin}`;
    
    this.dialog = false;
    
    // ✅ PASO 4: Consultar con las fechas exactas
    this.consultarIncidentesPorRango();
  } else {
    this.dateRangeDisplay = '';
    this.dialog = false;
  }
},
    
    actualizarFechaDisplay() {
      if (this.dateRange && this.dateRange.length === 2) {
        const [fechaInicio, fechaFin] = this.dateRange;
        const opcionesFormato = { year: 'numeric', month: '2-digit', day: '2-digit' };
        const fechaInicioFormateada = new Date(fechaInicio).toLocaleDateString('es-ES', opcionesFormato);
        const fechaFinFormateada = new Date(fechaFin).toLocaleDateString('es-ES', opcionesFormato);
        this.dateRangeDisplay = `${fechaInicioFormateada} - ${fechaFinFormateada}`;
      } else {
        this.dateRangeDisplay = '';
      }
    },
    
    actualizarGraficaCasosDias() {
      const canvas = document.getElementById("CasosDiasMes");
      if (!canvas) {
        console.error("Canvas 'CasosDiasMes' no encontrado.");
        return;
      }
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      if (this.chartCasosDias) {
        this.chartCasosDias.destroy();
        this.chartCasosDias = null;
      }
      if (!this.dataDias || !this.dataDias.labels || !this.dataDias.data) {
        return;
      }
      this.chartCasosDias = new Chart(ctx, {
        type: "bar",
        data: {
          labels: this.dataDias.labels,
          datasets: [
            {
              label: "Casos por días",
              data: this.dataDias.data,
              backgroundColor: "rgba(75, 192, 192, 0.5)",
              borderColor: "rgba(75, 192, 192, 1)",
              borderWidth: 1,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: true,
              position: "top",
            },
            tooltip: {
              enabled: false,
            },
          },
          interaction: {
            mode: 'none',
          },
          hover: {
            mode: null,
          },
          scales: {
            x: {
              grid: {
                display: true,
                drawBorder: true,
                color: "rgba(200, 200, 200, 0.3)",
              },
              ticks: {
                color: "#000",
              },
            },
            y: {
              beginAtZero: true,
              grid: {
                display: true,
                drawBorder: true,
                color: "rgba(200, 200, 200, 0.3)",
              },
              ticks: {
                color: "#000",
              },
            },
          },
        },
      });
    },

    actualizarGraficaRequerimientos() {
      const canvas = document.getElementById("CasosPorRequerimientos");
      if (!canvas) {
        console.error("Canvas 'CasosPorRequerimientos' no encontrado.");
        return;
      }
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      if (this.chartRequerimientos) {
        this.chartRequerimientos.destroy();
        this.chartRequerimientos = null;
      }
      this.chartRequerimientos = new Chart(ctx, {
        type: "horizontalBar",
        data: {
          labels: this.dataRequerimientos.labels,
          datasets: [
            {
              label: "Casos por requerimiento",
              data: this.dataRequerimientos.data,
              backgroundColor: "rgba(65, 121, 228, 0.5)",
              borderColor: "rgba(65, 121, 228, 1)",
              borderWidth: 1,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: true,
              position: "top",
            },
            tooltip: {
              enabled: false,
            },
          },
          interaction: {
            mode: 'none',
          },
          hover: {
            mode: null,
          },
          scales: {
            x: {
              beginAtZero: true,
            },
          },
        },
      });
    },

    actualizarGraficaEstadoCasos() {
      const canvas = document.getElementById("estadoDeCasos");
      if (!canvas) {
        console.error("Canvas 'estadoDeCasos' no encontrado.");
        return;
      }
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      if (this.chartEstadoCasos) {
        this.chartEstadoCasos.destroy();
        this.chartEstadoCasos = null;
      }
      this.chartEstadoCasos = new Chart(ctx, {
        type: "doughnut",
        data: {
          labels: ["Cerrados por usuarios", "Cerrados por robot", "Pendientes"],
          datasets: [
            {
              data: [this.cerradosUser, this.cerradoRobot, this.pendientesPorCerrar],
              backgroundColor: ["#EB3F3F", "#FF4406", "#0621FF"],
            },
          ],
        },
        options: {
          responsive: true,
          plugins: {
            tooltip: {
              enabled: false,
            },
          },
          interaction: {
            mode: 'none',
          },
          hover: {
            mode: null,
          },
        },
      });
    }
  }
};
</script>

<style scoped>
Overlay para oscurecer el fondo mientras se carga
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 202;
}

/* Contenedor del ícono y el texto */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* Estilo para el ícono mdi-reload */
.loading-icon {
  font-size: 70px;  /* Tamaño del ícono */
  color: #e2e4ec;  /* Color del ícono */
  animation: rotate 2s infinite linear;  /* Animación de rotación */
}

/* Animación de rotación para el ícono */
@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Estilo para el texto de "Cargando..." */
.loading-text {
  margin-top: 10px;  /* Espacio entre el ícono y el texto */
  font-size: 18px;
  color: #daddec;  /* Color del texto */
  font-weight: bold;
}
.fecha{
  margin: 28px 740px 0px 0px;
}
/* Estilo para la tarjeta principal que contiene el gráfico */
.card-chart-container {
  background-color: #f0f0f0; /* Fondo de la tarjeta */
  padding: 10px;  /* Padding interno reducido */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);  /* Sombra para resaltar */
  min-height: 350px;  /* Altura mínima */
  max-height: 500px;  /* Altura máxima para evitar desbordes */
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 18px 0 23px 0;
  overflow: hidden; /* Evitar desbordes */
}
/* Estilo para el título de la tarjeta (donde está el gráfico) */
.card-chart-title {
  display: flex;
  justify-content: center;
  padding: 0;
  
}
/* Estilo para el canvas (gráfico) */
.grafico-canvas {
  max-width: 100%;  /* El gráfico no excederá el ancho disponible */
  max-height: 100%;  /* El gráfico no excederá la altura disponible */
  width: 100% !important;
  height: auto !important;
}
/* Estilo para el texto dentro del gráfico (canvas) */
.card-chart-text {
  padding: 0;  /* Remover padding para asegurarse de que el canvas ocupe todo el espacio */
}
/* Estilo para el subtítulo de la tarjeta */
.title-card {
  font-size: 18px;  /* Tamaño de la fuente */
  color: #333;  /* Color del texto */
  font-weight: bold;
  text-align: center;
  padding: 8px 0;  /* Espaciado superior e inferior */
}
/* Estilo para el texto descriptivo debajo del gráfico */
.subtitle-card {
  font-size: 14px;
  color: #555;  /* Color de texto más suave */
  text-align: center;
  padding: 8px 0;
}
/* Estilo para la línea divisoria */
.v-divider {
  margin: 8px 0;  /* Espaciado superior e inferior de la línea divisoria */
}
/* ---------------------------- */
.card-chart {
  position: relative;
  top: -35px;
}
.card-chart--text {
  padding: 35px;
}
.containt-charts {
  margin-top: 50px;
}
.title-card {
  font-weight: bold;
  font-size: 16px;
  text-transform: uppercase;
}
.subtitle-card {
  font-size: 15px;
  text-transform: lowercase;
}

.card--color1 {
  background-color: rgba(163, 228, 150, 0.2);
}
.card--color2 {
  background-color: rgba(65, 121, 228, 0.2);
}
.card--color3 {
  background-color: rgba(235, 60, 60, 0.2);
}
.card--color4 {
  background-color: rgba(134, 235, 63, 0.2);
}
</style>